import React, { useRef, useState } from 'react';
import { sendEmail } from '../../services/FormService';

const inputStyle = {
  fontFamily: 'var(--font-sans)', fontSize: 14, padding: '12px 14px',
  border: '1px solid var(--border)', borderRadius: 10, background: 'var(--bg)',
  color: 'var(--fg)', width: '100%', outline: 'none',
  transition: 'border-color 140ms var(--ease-out), box-shadow 140ms var(--ease-out)',
};

export default function ContactBlock() {
  const formRef = useRef();
  const [sending, setSending] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    sendEmail(formRef);
    setSending(false);
  };

  return (
    <section style={{ background: 'var(--bg)', padding: '120px 32px', borderTop: '1px solid var(--border)' }}>
      <div style={{ maxWidth: 640, margin: '0 auto', textAlign: 'center' }}>
        <div style={{
          fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.18em',
          textTransform: 'uppercase', color: 'var(--fg-muted)', marginBottom: 24,
        }}>03 — Say hello</div>
        <h2 style={{
          fontFamily: 'var(--font-display)', fontWeight: 400,
          fontSize: 'clamp(48px, 6vw, 88px)', lineHeight: 1, letterSpacing: '-0.03em',
          margin: '0 0 24px',
        }}>Got an <em style={{ color: 'var(--accent)' }}>idea</em>?</h2>
        <p style={{ fontSize: 19, lineHeight: 1.6, color: 'var(--fg-muted)', margin: '0 0 40px' }}>
          We read every message. Send us a note about what you're working on — or just say hi.
        </p>

        <form ref={formRef} onSubmit={handleSubmit} style={{ textAlign: 'left', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div>
            <label style={{ fontSize: 12, fontWeight: 500, display: 'block', marginBottom: 6 }}>Name</label>
            <input
              type="text"
              name="first_name"
              placeholder="Your name"
              required
              style={inputStyle}
            />
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 500, display: 'block', marginBottom: 6 }}>Email</label>
            <input
              type="email"
              name="user_email"
              placeholder="you@example.com"
              required
              style={inputStyle}
            />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={{ fontSize: 12, fontWeight: 500, display: 'block', marginBottom: 6 }}>Message</label>
            <textarea
              name="message"
              placeholder="Tell us what you're working on…"
              required
              rows={5}
              style={{ ...inputStyle, resize: 'vertical', minHeight: 120, lineHeight: 1.55 }}
            />
          </div>
          <div style={{ gridColumn: '1 / -1', textAlign: 'center', marginTop: 8 }}>
            <button
              type="submit"
              disabled={sending}
              style={{
                fontFamily: 'var(--font-sans)', fontSize: 15, fontWeight: 500,
                padding: '14px 28px', borderRadius: 10, border: 'none',
                background: '#FF4D00', color: '#fff', cursor: 'pointer',
                opacity: sending ? 0.7 : 1,
                transition: 'background 140ms var(--ease-out)',
              }}
            >
              {sending ? 'Sending…' : 'Send message'} <span style={{ marginLeft: 6 }}>→</span>
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
